module.exports = __webpack_public_path__ + "img/icon-thoma.7be95231.webp";